import {
  SELECT_PRODUCTS_BASED_ON_SPECIFIC,
  SELECT_PRODUCTS_BASED_ON_TAGS
} from "../../../../../../../constants/selectProductsBasedOn.js";
import { AnyObject } from "final-form";


export const validation = (values) => {
  const errors: AnyObject = {};

  if (values.selectProductsBasedOn === SELECT_PRODUCTS_BASED_ON_SPECIFIC && !values.selectedSpecificItems.length) {
    errors.selectedSpecificItems = "Required";
  }

  if (values.selectProductsBasedOn === SELECT_PRODUCTS_BASED_ON_TAGS && !values.selectedTags.length) {
    errors.selectedTags = "Required";
  }

  return errors;
};